import React from 'react'
import _ from 'underscore'
import Checkbox from 'components/Checkbox'

import FormSection from 'pages/shared/FormSection'

type Props = {
  selectedTiers: Array<string>,
  onChangeCallback: (attributes: { tiers: Array<string> }) => void,
  errors?: { tiers?: string } | null,
}

const tierDisplayName = {
  basic: 'Basic',
  premium: 'Premium'
}

const TierFields = ({ selectedTiers, onChangeCallback, errors }: Props) => {
  const allTiers = ['basic', 'premium']

  const onTierChange = (tier) => {
    const updatedTiers = _.contains(selectedTiers, tier)
      ? _.without(selectedTiers, tier)
      : _.union(selectedTiers, [tier])

    onChangeCallback({ tiers: updatedTiers })
  }

  return (
    <FormSection title="Tiers">
      {
        allTiers.map((tier) => (
          <Checkbox
            key={tier}
            label={tierDisplayName[tier]}
            checked={selectedTiers.includes(tier)}
            onChange={() => onTierChange(tier)}
            errorMessage={_.last(allTiers) === tier ? errors?.tiers : null}
          />
        ))
      }
    </FormSection>
  )
}

export default TierFields
